import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  beneficiaryDetails: {
    primaryAccountHolder: boolean;
    patientName: string;
    patientId: number;
    isMinor: boolean;
    dateOfBirth: string;
  }[];

  claims: {
    ampsId: number;
    claimNumber: string;
    dateOfService: string;
    patientId: number;
    billedAmount: number;
    providerName: string;
    balanceBillStatus: {
      id: number;
      name: string;
      tip: string;
    };
  }[];
  limit: number;
  page: number;
  total: number;
  error: boolean;
  loading: boolean;
  errorMessage: string;
} = {
  beneficiaryDetails: [
    {
      primaryAccountHolder: false,
      patientName: "",
      patientId: 0,
      isMinor: false,
      dateOfBirth: "",
    },
  ],
  claims: [],
  limit: 20,
  page: 0,
  error: false,
  loading: false,
  errorMessage: "",
  total: 0,
};
const fetchAllClaimsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL_CLAIMS_STARTED: {
      return updateObject(state, {
        loading: true,
        claims: initialState.claims,
        error: false,
        limit: 20,
        page: 0,
        errorMessage: "",
        total: 0,
      });
    }
    case actionTypes.FETCH_ALL_CLAIMS_SUCCESS: {
      console.log("action.claims", action.claims);
      return updateObject(state, {
        claims: [...state.claims, ...action.claims],
        error: false,
        errorMessage: "",
        loading: false,
        limit: 20,
        page: state.page + 1,
        total: action.total,
      });
    }
    case actionTypes.FETCH_ALL_CLAIMS_FAILED:
    case actionTypes.RESET_FETCH_ALL_CLAIMS:
      return updateObject(state, {
        claims: initialState.claims,
        error: true,
        errorMessage: action.errorMessage,
        loading: false,
        limit: 20,
        page: 0,
        total: 0,
      });

    // return updateObject(state, {
    //   claims: initialState.claims,
    //   limit: 20,
    //   page: 0,
    //   error: false,
    //   loading: false,
    //   errorMessage: "",
    //   total: 0,
    // });
    default:
      return state;
  }
};
export default fetchAllClaimsReducer;
